import { useState } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Loader } from "@/components/ProtectedRoute";
import { toast } from "@/components/ui/use-toast";
import { createCorrectionInvoice } from "@/service/weexpertService";

import { useInvoiceCorrectionForm } from "./useInvoiceCorrectionForm";
import { InvoiceCorrectionFormActions } from "./InvoiceCorrectionFormActions";
import { OriginalInvoiceReferenceSection } from "./sections/OriginalInvoiceReferenceSection";
import { CorrectionDetailsSection } from "./sections/CorrectionDetailsSection";
import { CorrectionPositionsSection } from "./sections/CorrectionPositionsSection";
import { CorrectionSummarySection } from "./sections/CorrectionSummarySection";

export const InvoiceCorrectionForm = ({ invoiceId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [inputChecked, setInputChecked] = useState(false);

  const form = useInvoiceCorrectionForm(invoiceId);

  const mutation = useMutation({
    mutationFn: () => {
      setInputChecked(true);
      const errors = form.validate();
      if (errors.length > 0) {
        return Promise.resolve();
      }
      const submitData = form.getSubmitData();
      return createCorrectionInvoice(invoiceId, submitData);
    },
    onSuccess: (response) => {
      if (response?.data?.id) {
        toast({
          title: t("invoices:correction_created"),
        });
        navigate(`/admin/invoices/details/${response.data.id}`);
      }
    },
    onError: (error) => {
      console.error(error);
      toast({
        title: t("invoices:correction_error"),
        description: error.response?.data?.message || error.message,
        variant: "destructive",
      });
    },
  });

  const handleSave = () => {
    mutation.mutate();
  };

  if (form.isLoading) {
    return <Loader />;
  }

  if (!form.originalInvoice) {
    return (
      <div className="w-full p-8 text-center">
        <p className="text-red-500">{t("invoices:no_results")}</p>
      </div>
    );
  }

  return (
    <div className="w-full bg-grayLightMainBg">
      <InvoiceCorrectionFormActions
        onSave={handleSave}
        isPending={mutation.isLoading}
      />

      <div className="w-full pb-6 pt-6 px-8">
        <OriginalInvoiceReferenceSection originalInvoice={form.originalInvoice} />

      
          <CorrectionDetailsSection form={form} inputChecked={inputChecked} />
       

        <CorrectionPositionsSection form={form} inputChecked={inputChecked} />
        <CorrectionSummarySection form={form} />
      </div>
    </div>
  );
};
